import { ScanLine } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const MicrochipTip = ({ className = "" }) => {
  const { t } = useLanguage();
  return (
    <div data-testid="microchip-tip" className={`flex gap-3 rounded-xl border border-sky-200 bg-sky-50 px-4 py-3 ${className}`}>
      <ScanLine size={20} className="text-sky-600 shrink-0 mt-0.5" />
      <div>
        <p className="text-sm font-bold text-sky-900">{t("lfm_tip_title")}</p>
        <p className="text-sm text-sky-800 mt-0.5">{t("lfm_tip_body")}</p>
      </div>
    </div>
  );
};
